import { JobEquipment } from '../models/job-equipment.model';
export class AddJobEquipment {
    static readonly type = '[JobEquipment] Add';

    constructor(public payload: JobEquipment) {}
}

export class UpdateJobEquipmentList {
    static readonly type = '[JobEquipment] Update list';

    constructor(public payload: JobEquipment[]) {}
}

export class RemoveJobEquipment {
    static readonly type = '[JobEquipment] Remove';

    constructor(public payload: JobEquipment) {}
}


export class ClearJobEquipment {
    static readonly type = '[JobEquipment] Clear';

    constructor() {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-merge-customer/actions/job-equipment.action.ts